import { TechCertification } from "./models/TechCertification.ts";
import google_cloud_cert from "./images/googlecloudcert.png";
import sas_9_cert from "./images/sas9cert.png";

const TechCertifications = [
    new TechCertification("Google Cloud Certified Professional Data Engineer", "https://www.credential.net/26a4937f-f0af-45aa-b318-4fd2142ff984", google_cloud_cert),
    new TechCertification("SAS Certified Base Programmer for SAS 9", "https://www.credly.com/badges/b694f60d-53b0-4516-bcaf-bf374f2d093b", sas_9_cert),
];

export default TechCertifications;